export enum FloatingCornerElementName {
  FACETS_BUTTON = 'facets-button',
  QNA_QUESTION_BUTTON = 'qna-question-button'
}

export enum Corner {
  TOP_RIGHT = 'top-right',
  BOTTOM_RIGHT = 'bottom-right',
  BOTTOM_LEFT = 'bottom-left',
  TOP_LEFT = 'top-left'
}
